var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Long from "long";
import * as React from "react";
import { IdResource } from "../../../constants/IdResource";
import { IdTooltipAdjust } from "../../../constants/IdTooltipAdjust";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { utilBuff } from "../../../utils/utilBuff";
import { ButtonDefault } from "../../generic/button-buy/ButtonDefault";
import { ButtonPrimary } from "../../generic/common/ButtonPrimary";
import { IdIcon } from "../../generic/icon/IdIcon";
import { IdMissingResourceTypes } from "../../not-enough-resource/IdMissingResourceTypes";
import { IdTooltipAnchor, TooltipText } from "../../tooltip";
import { ExpansionGridImage } from "./GraphicExpansion";
import { RequirementsExpansions } from "./RequirementsExpansions";
import { UnlockMessageExpansions } from "./UnlockMessageExpansions";
var StandardPurchaseBuyExpansions = /** @class */ (function (_super) {
    __extends(StandardPurchaseBuyExpansions, _super);
    function StandardPurchaseBuyExpansions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getMoneyAmount = function () {
            var _a = _this.props, resources = _a.expansionTypeInfo.resources, expansionDiscountBuff = _a.expansionDiscountBuff;
            var standardResource = resources.find(function (item) { return item.resource.id === IdResource.Money; });
            var amount = standardResource ? standardResource.cost : Long.ZERO;
            return [
                amount,
                expansionDiscountBuff ? utilBuff.applyTo(amount, expansionDiscountBuff) : undefined,
            ];
        };
        _this.getMissingResourcesStandard = function () {
            var _a = _this.props, resources = _a.expansionTypeInfo.resources, expansionDiscountBuff = _a.expansionDiscountBuff;
            var missingResources = resources.reduce(function (missingCosts, costs) {
                var cost = costs.cost, available = costs.available, resource = costs.resource;
                var realCost = resource.id === IdResource.Money && expansionDiscountBuff
                    ? utilBuff.applyTo(cost, expansionDiscountBuff)
                    : cost;
                if (available.lessThan(realCost)) {
                    missingCosts.push({
                        available: available,
                        missing: realCost.subtract(available),
                        resource: resource,
                    });
                }
                return missingCosts;
            }, []);
            return {
                missingResources: missingResources,
                resourceType: IdMissingResourceTypes.Resources,
            };
        };
        return _this;
    }
    StandardPurchaseBuyExpansions.prototype.render = function () {
        var _a = this.props, expansionsSizeX = _a.expansionsSizeX, expansionsSizeY = _a.expansionsSizeY, onBuyExpansion = _a.onBuyExpansion, expansionTypeInfo = _a.expansionTypeInfo;
        var resources = expansionTypeInfo.resources, levelLock = expansionTypeInfo.levelLock, requiredLevel = expansionTypeInfo.requiredLevel, missingAmount = expansionTypeInfo.missingAmount;
        var missingResources = this.getMissingResourcesStandard();
        var _b = this.getMoneyAmount(), amount = _b[0], buffedAmount = _b[1];
        return (React.createElement("div", { className: "expansion-menu__standard " + IdStyles.BuyExpansionStandardBackground },
            React.createElement(ExpansionGridImage, { expansionsSizeX: expansionsSizeX, expansionsSizeY: expansionsSizeY }, levelLock && React.createElement(UnlockMessageExpansions, { requiredLevel: requiredLevel })),
            React.createElement("div", { className: "expansion-menu__content" },
                React.createElement(RequirementsExpansions, { resources: resources }),
                React.createElement(TooltipText, { id: IdLoca.tooltip_buyForDollars_web, anchor: IdTooltipAnchor.Bottom, adjustVertical: IdTooltipAdjust.Large },
                    React.createElement(ButtonDefault, { component: ButtonPrimary, icon: IdIcon.FarmDollarsIcn, amount: amount, buffedAmount: buffedAmount, onClick: function () { return onBuyExpansion(missingResources, missingAmount); }, disabled: levelLock })))));
    };
    return StandardPurchaseBuyExpansions;
}(React.PureComponent));
export { StandardPurchaseBuyExpansions };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/expansions/StandardPurchaseBuyExpansions.tsx
// module id = 2867
// module chunks = 3